import React from 'react'
import { IIconProps } from 'Interfaces'

export function FlooringIcon(props: IIconProps) {
    return (
        <svg  width={24} height={props.height ?? 16} viewBox="0 0 48 30" fill="none">
            <path d="M23.912 0L47.824 14.6733L23.912 29.3465L0 14.6733L23.912 0ZM14.824 7.92326L23.912 13.5L33 7.92326L23.912 2.34653L14.824 7.92326ZM34.912 9.09653L25.824 14.6733L34.912 20.25L44 14.6733L34.912 9.09653ZM33 21.4233L23.912 15.8465L14.824 21.4233L23.912 27L33 21.4233ZM12.912 20.25L22 14.6733L12.912 9.09653L3.82397 14.6733L12.912 20.25Z" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor"/>
            <path d="M23.912 15.8465L33 21.4233L23.912 27L14.824 21.4233L23.912 15.8465Z" fill="#6DD8FF"/>
            <path d="M23.912 13.5L14.824 7.92326L23.912 2.34653L33 7.92326L23.912 13.5Z" fill="#6DD8FF"/>
        </svg>
    )
}
